export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11902.15a47635.jpg";